var MessageCh = {

  NavabarText: {
    navbar_home: "主页",
    navbar_about: "关于我们",
    navbar_product:"产品中心",
    navbar_case: "案例中心",
    navbar_contact: "联络我们",
    navbar_item: "服务支持",
    navbr_new: '最新消息',
    navbr_join:'加入我们'
  },
  About_Navbar: {
    Company: '公司简介',
    Horor: '荣誉与资质',
    Technology: '科研技术',
    Team: '我们的团队',
  },
  New_NavBar: {
    Notice: '公司通告',
    MediaCentre: '媒体中心',
  },
  indexText: {

    more: "了解更多",
    home_title:"提供定制深度互联网",
    home_title_1:"解决方案",
    web_build:"网站建设",
    phone_build:"手机网站",
    min_build:"小程序定制",
    share_build:"公众号定制",
    
    content_title_1:'PC建站',
    content_title_content_1:'专注营销型、会SEO的网站',
    content_title_description_1:"海量高颜值设计模板+自适应，支持全屏DIY",
    content_title_description_1_1:"更专业SEO优化、Sitenam支持、保证百度收录",
    content_title_description_1_2:"更有多语言、大数据，员工子账号等你来撩",
    
    content_title_2:'精美型定制网站',
    content_title_content_2:'简单、易用的企业展示到店版+预约版',
    content_title_description_2:"对企业、客户、市场进行专业的分析，为企业建设官方形象网站。",
    content_title_description_2_1:"适用于中小规模或初创型企业，以展示产品、介绍服务为主。",

    
    content_title_3:'营销型定制网站',
    content_title_content_3:'专注营销型、会SEO的网站',
    content_title_description_3:"海量高颜值设计模板+自适应，支持全屏DIY",
    content_title_description_3_1:"更专业SEO优化、Sitenam支持、保证百度收录",
    content_title_description_3_2:"更有多语言、大数据，员工子账号等你来撩",

    content_title_4:'官网小程序',
    content_title_content_4:'简单、易用的企业展示到店版+预约版',
    content_title_description_4:"一次搞定小程序商城+微商城+电脑商城",
    content_title_description_4_1:"多终端覆盖，1000+全行业模板不断更新，个性化装修，优秀设计器",
    content_title_description_4_2:"全方位管理商品，订单，会员，数据，多种营销功能引爆销量",

    give_function:"提供全行业专业的解决方案",
    consulting_service:"更多行业可咨询我们的客服",

  },
  footText: {
    companys: '广州市优科易网络科技有限公司',
    address: "广州市白云区大源东宝街4号101铺",
    addresss: '广州市白云区大源东宝街4号101铺',
    phone: "电话:(+86) ",
    email: "电邮:",
    weixin: "扫码关注公众号",
    aboutUs: '关于我们',
    company: '公司简介',
    honor: '荣誉与资质',
    technology: '科研技术',
    team: '我们的团队',
    services: '服务项目',
    news: '最新消息',
    notice: '公司通告',
    mediaCentre: '媒体中心',
    contact: '联络我们',
    talentRecruitment: '人才招聘',
    OfficeHours: '营业时间',
    day1: '星期一至五',
    day2: '星期六至日',
    version: '版权所有 © 广州市优科易网络科技有限公司 2021-2022',
    back: '返回首页',

  },
  HomeText: {
  
  },
  AboutUs: {
    h_c: '关于我们',
    jj_t_1: '公司简介',
    jj_t_2: '关于优科易网络科技有限公司',
    j_t_1:'广州优科易网络科技有限公司以下简称：优易科,优易科是一家助力中小企业数字化经营升级的企业，公司拥有丰富项目经验的项目经理、专业界面设计师、交互设计师以及程序工程师。优易科提出 "做客户易懂的网络" 的口号。优易科提出 "让网络更简单" 的口号。',
    j_t_2:'我们为客户提供专业的定制网络建设服务。服务项目涵盖了网页视觉设计、VI标志设计、网站程序开发、HTML5响应式网站建设、手机网站开发、微商城、小程序开发、网站托管及维护、WEB系统开发、域名注册、国内外服务器租用、视频、平面设计、SEO优化排名等。帮助企业更容易的获取用户流量，为企业提升产品和创造价值提供最坚实的支撑。'


  },
  concat: {
    h_t: '联络我们',
    form_t: '期望与您联系',
    ph_1: '给我们意见',
    name: '请输入您的名字',
    phone:'请输入您的电话',
    need:'请输入您的需求',
    codemsg:'请输入验证码',
    ph_3: '电话',
    ph_4: '邮箱',
    sub_t: '提交',
    location: '广州市白云区大源东宝街4号101铺',

  },
  product:{
    type:'建站类型',
    type_title_1:'优科易管理系统',
    type_content_1:'功能强大、数据安全',
    type_title_2:'优科易商城',
    type_content_2:'一站式全包服务器域名',
    
    type_title_3:'电脑版商城',
    type_content_3:'全站关键词营销设置',
    
    type_title_4:'手机商城',
    type_content_4:'海量模块在线拖拽布局',
    
    type_title_5:'微信版商城',
    type_content_5:'海量模块在线拖拽布局',
    
    type_title_6:'小程序版商城',
    type_content_6:'海量模块在线拖拽布局',
    register:'立即注册',
    learMore:'了解更多',

    mall_title:'PC 商城',
    mall_content_title_1:'可视化编辑',
    mall_content_descript_1:'页面中所有的模块随意拖拽、编辑，所看即所得',
    mall_content_title_2:'海量商城模板',
    mall_content_descript_2:'PC端/移动端拥有海量商城模板，轻松打造“与众不同”的商城外观',
    mall_content_title_3:'移动端分类模板',
    mall_content_descript_3:'多种移动端分类模板，帮助顾客更容易找到所需商品',
    mall_content_title_4:'自定义页面',
    mall_content_descript_4:'制作自定义页面，可用于新品或促销专题，增加顾客体验',
  },
  case:{
    case_title:'相关案例',
    case_descript:'我们助您拥抱互联网新零售、新营销',

    case_title_1:'香港医务检测中心',
    case_descript_1:'专业、全面的一站式基因检测服务',

    case_title_2:'香港卓信医疗化验所',
    case_descript_2:'更高质素、更方便的基因检测科技',

    case_title_3:'香港万利分子检验中心',
    case_descript_3:'专业、准确、可靠的基因检测服务',

    case_title_4:'香港卓信医疗化验所',
    case_descript_4:'更高质素、更方便的基因检测科技',

    case_title_5:'报告系统',
    case_descript_5:'香港卓信医疗化验所报告系统',

    case_title_6:'工作系統',
    case_descript_6:'香港化驗所有限公司工作系统',

    case_title_7:'友易家',
    case_descript_7:'友易家业主 友易家用户',

    case_title_8:'善食商城',
    case_descript_8:'致力打造最专业的社区生鲜服务平台',

    port_type:'pc端',
    port_type_1:'app',
    port_type_2:'小程序',
  },

  services:{
    type:'服务理念',
    type_content:'优易科从策划、设计、前端开发、测试、验收、上线、运维指导我们精心做好每一步。',
    process:'服务流程',
    process_item_1_title:'规范的前期沟通',
    process_item_1_content:'根据您的需求我们将在三个工作日内为您做一份详尽的调研问卷、基本架构与报价，有助于一个项目的开始。',
    process_item_2_title:'界面设计风格',
    process_item_2_content:'我们擅长用心洞悉您企业及产品的内在，并用功能与美感兼顾的表现使其呈现于外，为您提供与视觉设计有关的一切。',
    process_item_3_title:'前端架构+后台开发',
    process_item_3_content:'开发团队遵循和约定的代码书写规范，提高代码的规范性和可维护性，规范编码便于日后功能拓展，减少系统维护成本。',
    process_item_4_title:'测试验收',
    process_item_4_content:'根据页面和需求进行程序的开发及前后端页面的整合测试，项目完成后，客户可在我们提供测试网址上进行验收。',
    center:'服务中心',
    center_1_title:'提供 "7x12小时" 客服热线电话服务和 "7x8小时" 技术支持服务。',
    center_2_title:'收到技术支持需求第一时间为用户服务，保证服务时效性。',
    center_3_title:'定期跟踪项目进度以保证项目高质、 高效完成。',
    center_4_title:'售后主动回访，随时了解产品使用情况及建议不断改进提升。',
    
  },
  notices: {
    h_t: "公司通告"
  },
  ContractText:{
    termsofuse:'版权所有 © 广州市优科易网络科技有限公司 2021',
  },
};


export {

  MessageCh

}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js